import type { AddressValidationBodyProps, AddressValidationResponse } from './types'
import { getAddressValidationUrl } from '../../../constants/ccAppServiceUri'
import { ApiCCApp } from '../api/endpoints'

const submitValidateAddress = async (
  body: AddressValidationBodyProps
): Promise<AddressValidationResponse> => {
  // For reference:
  // https://cc-applications.internal.gcp.missionlane-dev.com/swagger-ui/index.html#/AddressValidation/addressValidation
  const addressValidationUrl = getAddressValidationUrl()

  const response = await ApiCCApp.post<AddressValidationBodyProps, AddressValidationResponse>(
    addressValidationUrl,
    body
  )

  return response.data
}

export default submitValidateAddress
